import { z } from 'zod';

import {
  VALIDATION_LIMITS,
  VALIDATION_MESSAGES,
} from '../../constants/ValidationRules';

export const templateSchema = z.object({
  id: z.number(),
  cssContent: z.null(),
  htmlContent: z.string(),
  hasWrapper: z.boolean(),
  title: z
    .string()
    .trim()
    .min(1, { message: 'Description is required' })
    .min(3, { message: 'Description must be at least 3 characters' })
    .max(VALIDATION_LIMITS.TEMPLATE.TITLE_MAX, {
      message: VALIDATION_MESSAGES.maxChars(
        VALIDATION_LIMITS.TEMPLATE.TITLE_MAX
      ),
    }),
  createdAt: z.string(),
  updatedAt: z.string(),
  templateOptions: z.string({ required_error: 'Template Option is required' }),
  idExternal: z.null(),
  components: z.null(),
});

export const templateCreateSchema = templateSchema.pick({
  title: true,
  templateOptions: true,
});

export const groupTemplateNamingSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, { message: 'Course template name is required' })
    .max(VALIDATION_LIMITS.TEMPLATE.NAME_MAX, {
      message: VALIDATION_MESSAGES.maxChars(
        VALIDATION_LIMITS.TEMPLATE.NAME_MAX
      ),
    }),
  templateOptions: z
    .number()
    .min(0, { message: 'Please select a template option' }),
});

export type TemplateSchema = z.infer<typeof templateSchema>;

export type TemplateCreateSchema = z.infer<typeof templateCreateSchema>;

export type GroupTemplateNamingSchema = z.infer<
  typeof groupTemplateNamingSchema
>;
